/**
 * Returns true when the value is a plain object record.
 */
export function is_record(
  value: unknown
): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

/**
 * Reads a string field from a record when present.
 */
export function read_string(
  record: Record<string, unknown>,
  key: string
): string | null {
  const value = record[key];
  return typeof value === "string" ? value : null;
}

/**
 * Reads a boolean field from a record when present.
 */
export function read_boolean(
  record: Record<string, unknown>,
  key: string
): boolean | null {
  const value = record[key];
  return typeof value === "boolean" ? value : null;
}

/**
 * Reads a number field from a record when present.
 */
export function read_number(
  record: Record<string, unknown>,
  key: string
): number | null {
  const value = record[key];
  return typeof value === "number" ? value : null;
}

/**
 * Reads an array field from a record when present.
 */
export function read_array(
  record: Record<string, unknown>,
  key: string
): readonly unknown[] | null {
  const value = record[key];
  return Array.isArray(value) ? value : null;
}
